import { render, staticRenderFns } from "./setGps.vue?vue&type=template&id=59cad549&"
import script from "./setGps.vue?vue&type=script&lang=js&"
export * from "./setGps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports